import {fullReady} from "@webreact/webreactor";
import {handleFilterButtonClick} from './archive-filter';
import 'readmore-js';

__webpack_public_path__ = document.head.querySelector('meta[name="base_assets"]').content;

/**
 * Fire this function when the document is fully loaded.
 * It takes no parameters and should return nothing.
 *
 * @return void
 */
function loaded() {

    jQuery(function ($) {
        // Hide description
        //if ($(window).width() < 960) {
        const read_more$ = $('.term-description');
        read_more$.readmore({
            collapsedHeight: 170,
            moreLink: '<a href="#">Verder lezen <i\n' +
                '                    class="fa fa-chevron-down"></i></a>',
            lessLink: '<a href="#">Minder informatie <i\n' +
                '                    class="fa fa-chevron-up"></i></a>',
            beforeToggle: function () {
                // ReadmoreJS does not change the aria-attributes here.
                read_more$.attr('aria-expanded', read_more$.attr('aria-expanded') === 'false' ? 'true' : 'false');
            }
        });

        handleFilterButtonClick();
    })

}

fullReady(loaded);
